export const order_key = {
    order_type: 'order_type',
    delivery_fulfilled_by: 'delivery_fulfilled_by',
    order_categories: 'order_categories',
    sub_categories: 'sub_categories',
    order_items: 'order_items',
    order_components: 'order_components',
    delivery_address: 'delivery_address',
    pick_up_store: 'pick_up_store',
    pick_up_time: 'pick_up_time',
    cart: 'cart',
    order_notes: "order_notes",
    total_amount: 'total_amount',
    estimate_order_result: 'estimate_order_result',
    pickup_stores: 'pickup_stores',
    order_status:'order_status',
    accept_change_fulfilled: 'accept_change_fulfilled',
    order_favourite_shop:'order_favourite_shop',
    crosssell: 'crosssell',
    being_selected_product: 'being_selected_product',
    cache_order_to_be_process: 'cache_order_to_be_process',
    cache_reponse_url: 'cache_reponse_url',
    contact_phone_order: 'contact_phone_order',
    order_token: 'order_token',
    catalog_selected: 'catalog_selected',
    estimate_cart_item: 'estimate_cart_item',
}
export function clearSessionOrder(){
    localStorage.removeItem(order_key.order_type);
    localStorage.removeItem(order_key.delivery_fulfilled_by);
    localStorage.removeItem(order_key.order_categories);
    localStorage.removeItem(order_key.sub_categories);
    localStorage.removeItem(order_key.order_items);
    localStorage.removeItem(order_key.order_components);
    localStorage.removeItem(order_key.delivery_address);
    localStorage.removeItem(order_key.pick_up_store);
    localStorage.removeItem(order_key.pick_up_time);
    localStorage.removeItem(order_key.cart);
    localStorage.removeItem(order_key.order_notes);
    localStorage.removeItem(order_key.total_amount);
    localStorage.removeItem(order_key.estimate_order_result);
    localStorage.removeItem(order_key.pickup_stores);
    localStorage.removeItem(order_key.order_status);
    localStorage.removeItem(order_key.accept_change_fulfilled);
    localStorage.removeItem(order_key.crosssell);
    localStorage.removeItem(order_key.being_selected_product);
    localStorage.removeItem(order_key.cache_order_to_be_process);
    localStorage.removeItem(order_key.estimate_cart_item);
    localStorage.removeItem(order_key.catalog_selected);
}

export function clearOrder(){
    localStorage.removeItem(order_key.order_type);
    localStorage.removeItem(order_key.delivery_fulfilled_by);
    localStorage.removeItem(order_key.pick_up_time);
    localStorage.removeItem(order_key.cart);
    localStorage.removeItem(order_key.order_notes);
    localStorage.removeItem(order_key.total_amount);
    localStorage.removeItem(order_key.estimate_order_result);
    localStorage.removeItem(order_key.accept_change_fulfilled);
    localStorage.removeItem(order_key.crosssell);
    localStorage.removeItem(order_key.being_selected_product);
    localStorage.removeItem(order_key.cache_order_to_be_process);
}
export function setOrderCache(key,value,isString){
   // console.log('key=======',key)
   // console.log('value=======',value)
    try{
        if(!isString)
        value = JSON.stringify(value);

  //  console.log('value1=======',value)
    localStorage.setItem(key, value);
    }
    catch(ex){
        console.log("save data to local storage for order exception:",ex);
    }

}

export function getOrderCache(key,isString){
    try{
        var value = localStorage.getItem(key);
        if(value && !isString){
            value = JSON.parse(value);
            
        }
        return value;
    }
    catch(ex){
        console.log("get data to local storage for order exception:",ex);
        return null;
    }
}

export async function addToCart(itemTobeAdded){
    var cartExisting = getOrderCache(order_key.cart);
    var newCart = [];
    if(!cartExisting || cartExisting.length == 0){
        newCart.push(itemTobeAdded);
    }else{
        var isExit = false;
        cartExisting.forEach(item => {
            if (item.id === itemTobeAdded.id && !item.components && !itemTobeAdded.components) {
                isExit = true;
                item.quantity = item.quantity + itemTobeAdded.quantity;
                item.amount = item.amount + itemTobeAdded.amount;
                item.totalAmount = item.totalAmount + itemTobeAdded.totalAmount;
            }
            newCart.push(item);
        });
        if (!isExit) {
            newCart.push(itemTobeAdded);
        }
    }
    //console.log('newCarrt===', newCart)
    setOrderCache(order_key.cart,newCart)
}

export async function removeFromCart(itemToRemove){
    removeCrosssellProducts({product_id: itemToRemove.key})
    var cart = getOrderCache(order_key.cart);
    var newCart = cart.filter(item => {
        return item.key != itemToRemove.key
    })
    setOrderCache(order_key.cart,newCart)
}
// export async function addItemToCrosssell(data){
//     var crosssell_products = getOrderCache(order_key.crosssell);

//     if(!crosssell_products||crosssell_products.length ==0 || data.length == 0){
//         crosssell_products = data;
//     }else{
//         for(let i =0;i< data.length ;i++){
//             var product = data[i];
//             var itemExist = crosssell_products.filter(p => {
//                 return p.id == product.id
//             })
//             if(!itemExist || itemExist.length ==0){
//                 crosssell_products.push(product);
//             } 
//         }
//     }

//     setOrderCache(order_key.crosssell,crosssell_products)
// }

export function addItemToCrosssell(data){
    //console.log("AAAA setCrosssellProducts data:",data);
    var crosssell_products = getOrderCache(order_key.crosssell);
    if(!crosssell_products){
        crosssell_products = []
    }

    if(data){ 
        var itemExist = crosssell_products.filter(p => {
            return p.product_id == data.product_id
        })
        if(!itemExist || itemExist.length ==0){
            crosssell_products.push(data);
        } 
    }

    setOrderCache(order_key.crosssell,crosssell_products)
    //console.log("AAAA setCrosssellProducts crosssell_products:",crosssell_products);
}

export function removeCrosssellProducts(data){
    //console.log("Aaaaaaa removeCrosssellProducts data:",data)
    var crosssell_products = getOrderCache(order_key.crosssell);
    if(crosssell_products&&crosssell_products.length > 0 && data){
        crosssell_products = crosssell_products.filter(p => {
            return p.product_id != data.product_id;
        })
    }
    //console.log("Aaaaaaa removeCrosssellProducts crosssell_products:",crosssell_products)
    setOrderCache(order_key.crosssell,crosssell_products)
}

export function getCrosssellProducts(){
    var data = [];
    var crosssell_products = getOrderCache(order_key.crosssell);
    //console.log("AAAA getCrosssellProducts data:",crosssell_products);
    if(crosssell_products&&crosssell_products.length > 0){
        for(let i=0;i<crosssell_products.length;i++){
            if(data.length == 0){
                if(crosssell_products[i].crosssells)
                    data.push(...crosssell_products[i].crosssells)
            }else{
                var crosssells = crosssell_products[i].crosssells;
                if(crosssells){
                    for(let j=0;j< crosssells.length ;j++){
                        var itemExist = data.filter(d => {
                            return d.id == crosssells[j].id
                        })
                        if(!itemExist || itemExist.length == 0){
                            data.push(crosssells[j])
                        }
                    }
                }

            }
        }
    }
    //console.log("AAAA getCrosssellProducts data2:",data);
    return data;
}

export async function setBeingSelected(payload) {
    var amount = 0;
    if (payload.pricing && payload.pricing.length > 0) {
        amount = payload.pricing[0].price;
    }
    var item = {
        id: payload.id,
        quantity: 1,
        name: payload.name,
        amount: amount,
        creatives: payload.creatives,
        description: payload.description,
        org_product_name: payload.name,
        type: payload.type_composition,
        pricing: payload.pricing
    }
    await setOrderCache(order_key.being_selected_product,item);
}